module.exports = __webpack_public_path__ + "img/94.b24bc8f0.png";